export default __webpack_public_path__ + "static/media/Threejs_101.84fdd7af.avif";